import React from 'react';
export default function Divider(props) {
    const { align = "center", className = "", style = {}, vertical = false } = props;

    let _class = `ui-divider ui-divider-${align}`;
    if(className){
        _class += " " + className; 
    }
    
    if(vertical){
        return(<div style={{...style}} className={"ui-divider-vert"}></div>)
    }
    return (
        <div style={{...style}} className={_class}>
            {(props.children && <div className="ui-divider-text">{props.children}</div>)}
        </div>
    );
};
